import React, { useEffect, useState } from 'react';
import { onSyncStatus, SyncStatus, forceDrain } from '../services/syncManager';
import { useAuth } from '../contexts/AuthContext';

const OfflineBanner: React.FC = () => {
  const [status, setStatus] = useState<SyncStatus>({ online: true, syncing: false, pendingCount: 0 });
  // The device can be perfectly online while the backend is mid-deploy —
  // navigator.onLine says nothing about that, so surface it separately.
  const { backendDegraded } = useAuth();

  useEffect(() => onSyncStatus(setStatus), []);

  if (status.online && !backendDegraded && status.pendingCount === 0) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 'max(12px, env(safe-area-inset-bottom))',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      padding: '8px 16px',
      borderRadius: 24,
      fontSize: 13,
      fontWeight: 500,
      color: '#fff',
      background: status.online && !backendDegraded ? 'var(--primary, #1a73e8)' : '#555',
      boxShadow: '0 2px 12px rgba(0,0,0,0.25)',
      whiteSpace: 'nowrap' as const,
    }}>
      {!status.online && (
        <>
          <span style={{ fontSize: 16 }}>&#x26A0;</span>
          <span>Offline</span>
        </>
      )}
      {status.online && backendDegraded && (
        <>
          <span style={{ fontSize: 16 }}>&#x21BB;</span>
          <span>Reconnecting…</span>
        </>
      )}
      {status.pendingCount > 0 && (
        <>
          {status.syncing ? (
            <span>Syncing {status.pendingCount} change{status.pendingCount > 1 ? 's' : ''}…</span>
          ) : (
            <>
              <span>{status.pendingCount} pending</span>
              {status.online && (
                <button
                  onClick={forceDrain}
                  style={{
                    background: 'rgba(255,255,255,0.2)',
                    border: 'none',
                    color: '#fff',
                    borderRadius: 12,
                    padding: '2px 10px',
                    cursor: 'pointer',
                    fontSize: 12,
                  }}
                >
                  Sync now
                </button>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default OfflineBanner;
